export default function Container({ children, containerId, prefix }) {
  return <div id="container" className={`${prefix}p-3 ${prefix}h-full ${containerId}`}>{children}</div>;
}
